import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { BlogPostImageInterface } from 'common/types/entities/BlogPostImageInterface'
import { Appearance } from 'common/types/entities/EntityInterface'
import React from 'react'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { useUpdateEntity, useUpdateProp } from '../hooks/useUpdateProps'
import DeviceAppearance from '../options/DeviceAppearance/DeviceAppearance'
import HtmlAttrId from '../options/HtmlAttrId'
import Border from '../styles/Border'
import ShadowStyle from '../styles/ShadowStyle'

function BlogPostImageSettings({ entity }: { entity: BlogPostImageInterface }) {
  const updateEntity = useUpdateEntity<BlogPostImageInterface>()
  const updateProp = useUpdateProp(entity)

  const { isMobile } = useDeviceModeContext()

  function updateAppearance(appearance: Appearance) {
    updateEntity({
      ...entity,
      appearance,
    })
  }

  return (
    <>
      <Border
        update={updateProp('border')}
        mobileUpdate={updateProp('mobileBorder')}
        border={entity.border}
        mobileBorder={entity.mobileBorder}
      />
      <ShadowStyle
        shadow={entity.boxShadow}
        mobileShadow={entity.mobileBoxShadow}
        update={updateProp('boxShadow')}
        mobileUpdate={updateProp('mobileBoxShadow')}
      />
      <ColorPickerControl
        isGradientAvailable
        label="background color"
        color={entity.background}
        mobileColor={entity.mobileBackground || entity.background}
        update={updateProp('background')}
        mobileUpdate={updateProp('mobileBackground')}
        isClearable
      />
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearance
        update={updateAppearance}
        desktop={entity.appearance.desktop}
        mobile={entity.appearance.mobile}
      />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default BlogPostImageSettings
